import { tuiAssert } from '@taiga-ui/cdk/classes';
import { FormArray, FormGroup } from '@angular/forms';

function distanceBetweenTouches({ touches }) {
    return Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
}

function easeInOutQuad(t) {
    tuiAssert.assert(0 <= t && t <= 1, 'Input must be between 0 and 1 inclusive but received ', t);
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}

function isPresent(value) {
    return value !== null && value !== undefined;
}

/**
 * If the value is null or undefined, returns default value
 * @param value
 * @param fallback alternative fallback
 * @deprecated use nullish coalescing operator
 */
function fallbackValue(value, fallback) {
    return isPresent(value) ? value : fallback;
}

/**
 * Flattens two dimensional array and calculates resulting length
 *
 * @param array twi dimensional array
 */
function flatLength(array) {
    return array.reduce((count, section) => count + section.length, 0);
}

/**
 * Extracts original array from {@link QueryList} rather than
 * creating a copy like {@link QueryList.toArray} does.
 * @param queryList
 * @returns original array from {@link QueryList}.
 */
function getOriginalArrayFromQueryList(queryList) {
    let array = [];
    queryList.find((_item, _index, originalArray) => {
        array = originalArray;
        return true;
    });
    return array;
}

function getSwipeDirection(deltaX, deltaY) {
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
        return deltaY > 0 ? 'top' : 'bottom';
    }
    else {
        return deltaX > 0 ? 'left' : 'right';
    }
}

/**
 * @deprecated: use identity from rxjs
 */
function identity(item) {
    return item;
}

function isElementEditable(element) {
    // TODO: iframe warning
    return ((element instanceof HTMLInputElement && !element.readOnly) ||
        (element instanceof HTMLTextAreaElement && !element.readOnly) ||
        element.isContentEditable);
}

function isNumber(value) {
    return typeof value === 'number';
}

function markControlAsTouchedAndValidate(control) {
    if (control instanceof FormArray) {
        control.controls.forEach(nestedControl => {
            markControlAsTouchedAndValidate(nestedControl);
        });
    }
    if (control instanceof FormGroup) {
        Object.values(control.controls).forEach(nestedControl => {
            markControlAsTouchedAndValidate(nestedControl);
        });
    }
    control.markAsTouched();
    control.updateValueAndValidity();
}

/**
 * Checks identity for nullable elements.
 *
 * @param a element a
 * @param b element b
 * @param handler called if both elements are not null
 * @return true if either both are null or they pass identity handler
 */
function nullableSame(a, b, handler) {
    if (a === null) {
        return b === null;
    }
    if (b === null) {
        return false;
    }
    return handler(a, b);
}

function uniqBy(array, key) {
    return Array.from(array
        .reduce((map, item) => (map.has(item[key]) ? map : map.set(item[key], item)), new Map())
        .values());
}

/**
 * Generated bundle index. Do not edit.
 */

export { distanceBetweenTouches, easeInOutQuad, fallbackValue, flatLength, getOriginalArrayFromQueryList, getSwipeDirection, identity, isElementEditable, isNumber, isPresent, markControlAsTouchedAndValidate, nullableSame, uniqBy };

//# sourceMappingURL=taiga-ui-cdk-utils-miscellaneous.js.map